import { Component, OnInit } from '@angular/core';
import { BasicList } from '../../../classes';
import { DiscountLimitApi } from '../../../../assets/js/lb-sdk';
import { BsModalService } from 'ngx-bootstrap';
import { ProductsService } from '../../../services';
import { ToastrService } from 'ngx-toastr';
import { Event } from '../../../interfaces';
import { DiscountLimitFormComponent } from './discount-limit-form/discount-limit-form.component';

@Component({
  selector: 'app-discount-limits',
  templateUrl: './discount-limits.component.html',
  styleUrls: ['./discount-limits.component.css']
})
export class DiscountLimitsComponent extends BasicList {
  constructor(
    private discountLimitApi: DiscountLimitApi,
    private modalService: BsModalService,
    private productsService: ProductsService,
    private toast: ToastrService
  ) {
    super();
    this.searchSettings = {
      searchFields: [],
      searchableFields: [
        { name: 'productType', placeholder: 'Product Type', optionsFunction: () => {
          return (this.productsService.getProductTypes() || [])
            .map(productType => {
              return {
                value: productType.name,
                description: productType.description
              };
            });
        } }
      ],
      filters: {}
    };
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.settings = {
      createComponent: DiscountLimitFormComponent,
      api: this.discountLimitApi,
      ModalService: this.modalService
    };
  }

  modify(data) {
    const { id, productType, value } = data;
    this.edit({
      id,
      productType: this.productsService.getProductTypeByName(productType),
      discount: value
    });
  }

  eventListener(event: Event) {
    switch (event.event) {
      case 'createModal:completed':
        this.toast.success('Discount limit successfully created', 'Discount Limit');
        this.getList();
        break;
      case 'editModal:completed':
        this.toast.success('Discount limit successfully updated', 'Discount Limit');
        this.getList();
        break;
      case 'delete:success':
        this.toast.success('Discount limit successfully deleted', 'Discount Limit');
        this.getList();
        break;
      case 'initialized':
        this.getList();
        break;
    }
  }
}
